export * from './reset-password-page.component';
